import { CdkDragDrop, DragRef, DropListRef } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { RouteCompress, Stop } from '../../../../@core/models/live-route';
import { DashboardBase } from '../dashboard.base';

@Component({
  selector: 'ngx-tabroutelist',
  templateUrl: './tabroutelist.component.html',
  styleUrls: ['./tabroutelist.component.scss']
})
export class TabRouteListComponent extends DashboardBase implements OnInit {
  exception: number;
  liveRouteStatus: number;

  ngOnInit() {
    this._stopService.initialiseRoute();
  }

  dropHeader(event: CdkDragDrop<Stop[]>) {
    let prevIndex = 0;

    let StopNumber = 0;
    const OldRouteId = event.item.data.Route_ID;
    const NewRouteId = Number(event.container.id);
    const routeToMove = event.container.data
    console.log(event)
    if (event.previousContainer.id === 'tableOnHold') {
      this.exception = 708;
      this.liveRouteStatus = 1;
      const UISelectedRouteId = this._stopService.RouteID;

      if (this._onholdService.selectedStops.length == 0) {
          this._onholdService.GetStop(event.item.data.Consol_ID).IsSelected = true;
      }

      this.BatchmoveToInRoute(this._onholdService.selectedStops, NewRouteId, StopNumber, routeToMove);
    } else if (event.previousContainer.id === 'stopTable') {
      if (this._stopService.selectedStops.length == 0) {
        this._stopService.GetStop(event.item.data.Consol_ID).IsSelected = true;
      }
      this.BatchmoveToInRoute(this._stopService.selectedStops, NewRouteId, StopNumber,routeToMove);
    }
  }

  entered(event: any) {
    const element = document.querySelector('.cdk-drag-placeholder');
    for (let i = 0; i < element.children.length; i++) {
      const el = <HTMLElement>element.children[i];
      el.style.visibility = 'hidden';
    }
  }

  exited(event: any) {
    const elements = document.querySelectorAll('.cdk-drag-placeholder');
    elements.forEach((el: HTMLElement) => {
      el.style.visibility = 'visible';
    });
  }

  showDropzones() {
    const elements = document.querySelectorAll('.dropzoneRoutes');
    elements.forEach((element: HTMLElement) => {
      element.style.height = '120px';
    });
  }

  hideDropzones() {
    const elements = document.querySelectorAll('.dropzoneRoutes');
    elements.forEach((element: HTMLElement) => {
      element.style.height = 'auto';
    });
  }

  // Check if an drag n drop stop is possible into route. 
  evenPredicate = (drag: DragRef, drop: DropListRef) => {
    let rtn = false;
    if(drag.data.DeliveryGreen){
      // If stop is green
      if(drop.data.IsGreen){
        // if route is green
        rtn = true;
      }else{
        rtn = false;
      }
    }else{
      rtn = true;
    }
    return rtn;
  }

  public selectItem(tab: RouteCompress) {
    
    this.isLoading = true;
    //this._stopService.setLoadingInProgress(true);
    //this._stopService.selectedRouteTotalDistance = Math.trunc(tab.TotalKm);
    this._stopService.RouteID = tab.Route_ID;
    //this._stopService.setDataNotOptimized(false);
    this._stopService.RouteDate = this._sectorService.RouteDate;
    this._optimizationService.RouteID = tab.Route_ID;
    this._optimizationService.RouteDate = this._sectorService.RouteDate;
    this.agmGoogleMapService.poly = null;
    this._stopService.initialiseRoute();
    //this._optimizationService.initialiseOptimization();
    this._sectorService.routeid = tab.Route_ID;
    //this.isLoading = false;
  }
}
